import { OverlayTrigger, Popover, PopoverContent, Modal } from 'react-bootstrap';

const Tooltip = ({ children, icon, placement = 'top', trigger = ['hover', 'focus'], style }) => {
  return (
    <OverlayTrigger
      placement={placement}
      trigger={trigger}
      overlay={
        <Popover style={style}>
          <PopoverContent>{children}</PopoverContent>
        </Popover>
      }
    >
      {icon ?? <div className="info" style={{ width: '1rem', marginRight: '0.5rem' }}></div>}
    </OverlayTrigger>
  );
};

export default Tooltip;
